import { Check, CopySimple } from "@phosphor-icons/react";
import clsx from "clsx";

import { Button } from "common/components/ui/Button";
import { Input, type InputProps } from "common/components/ui/Input";
import useCopyText from "common/hooks/useCopyText";

interface CopiableInputProps extends InputProps {
  value: string;
  isLoading?: boolean;
}

export default function CopiableInput({
  value,
  className,
  isLoading,
  ...rest
}: CopiableInputProps) {
  const { isCopied, copyText } = useCopyText(value);

  return (
    <div className={clsx("flex gap-x-2.5", className)}>
      <Input value={value} {...rest} className="flex-1" disabled />
      <Button
        variant="outline-black"
        intent="iconOnly"
        onClick={copyText}
        size={rest.variant}
        aria-label="copy text"
        isLoading={isLoading}
        disabled={!value}
      >
        {isCopied ? <Check /> : <CopySimple />}
      </Button>
    </div>
  );
}
